import type { Locale } from "date-fns";
import { format } from "date-fns";
import { enGB } from "date-fns/locale/en-GB";
import { enUS } from "date-fns/locale/en-US";
import { de } from "date-fns/locale/de";
import { es } from "date-fns/locale/es";
import { fr } from "date-fns/locale/fr";
import { it } from "date-fns/locale/it";
import { nl } from "date-fns/locale/nl";
import { nb } from "date-fns/locale/nb";
import { sv } from "date-fns/locale/sv";
import { da } from "date-fns/locale/da";
import i18n from "./index";

const LOCALE_MAP: Record<string, Locale> = {
  en: enGB,
  "en-us": enUS,
  "en-gb": enGB,
  de,
  es,
  fr,
  it,
  nl,
  no: nb,
  sv,
  da,
};

export function getDateFnsLocale(language?: string): Locale {
  const code = (language || i18n.language || "en-US").toLowerCase();
  return LOCALE_MAP[code] || LOCALE_MAP[code.split("-")[0]] || enGB;
}

/** Calendar columns stay Sunday-first, regardless of the locale's preferred week start. */
export function getSundayFirstWeekdays(language?: string): { label: string; name: string }[] {
  const locale = getDateFnsLocale(language);
  // January 1, 2023 was a Sunday. Use calendar dates rather than locale weekStartsOn.
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(2023, 0, index + 1);
    return {
      label: format(day, "EEEEE", { locale }),
      name: format(day, "EEEE", { locale }),
    };
  });
}

export function getBcp47Locale(language?: string): string {
  const code = (language || i18n.language || "en-US").toLowerCase();
  switch (code) {
    case "en-us":
      return "en-US";
    case "en-gb":
    case "en":
      return "en-GB";
    case "no":
      return "nb-NO";
    case "de":
      return "de-DE";
    case "es":
      return "es-ES";
    case "fr":
      return "fr-FR";
    case "it":
      return "it-IT";
    case "nl":
      return "nl-NL";
    case "sv":
      return "sv-SE";
    case "da":
      return "da-DK";
    default:
      return "en-US";
  }
}
